import { INDICATORS, type Indicator } from '@/lib/assessment/namatAssessment';

// Which health-indicator columns a user shows in the clinical beneficiaries
// table (#93, Dr. AlMamoon's #67). Saved per user as an array of indicator
// keys; anything unknown is dropped and the order is always INDICATORS order.

/** What a user sees before choosing: the three results that count in the Namat scale. */
export const DEFAULT_CLINICAL_COLUMNS: Indicator[] = ['bmi', 'bloodPressure', 'hba1c'];

export function normalizeClinicalColumns(saved: unknown): Indicator[] {
  if (!Array.isArray(saved)) return DEFAULT_CLINICAL_COLUMNS;
  return INDICATORS.filter((key) => saved.includes(key));
}

export function toggleClinicalColumn(columns: Indicator[], key: Indicator): Indicator[] {
  return normalizeClinicalColumns(columns.includes(key) ? columns.filter((c) => c !== key) : [...columns, key]);
}
